import http from "../../../request";

export default {
  biography: async (context) => {
    let response = await http.get("biography", localStorage.getItem("lang"));
    context.commit("setAbout", response);
  },
  personalPhotos: async (context,payload) => {
    let year;
    if(!payload?.year){
      year='all';
    }
    else{
      year=payload.year;
    }
    if (!context.state.allPhotosLoaded) {
      context.commit("noResult", false);

      let response = await http.get(
        `personal_photos/filter/${year}`,
        `${localStorage.getItem("lang")}&page=${context.state.page}`
      );
      context.commit("setPersonalPhotos", response.data);
      if(response.data.length==0){
        context.commit("noResult", true);
      }
      context.commit("setMeta", response.meta);
      if (context.state.meta) {
        if (context.state.meta.last_page > context.state.page) {
          context.commit("increasePage");
        } else {
          context.commit("allPhotosLoaded", true);
        }
      }
    }
  },
  resetPhotos(context) {
    context.commit("reset");
  },
};
